export const GET_SINGLE_START='GET_SINGLE_START';
export const GET_SINGLE_SUCCESS='GET_SINGLE_SUCCESS';
export const GET_SINGLE_FAIL='GET_SINGLE_FAIL';